import * as React from "react";

import { cn } from "@/lib/utils";

export interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  subtitle,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <div
      className={cn("flex items-start justify-between gap-4 py-1", className)}
    >
      <div className="flex flex-col gap-1 min-w-0">
        <h1 className="text-[26px] font-semibold tracking-tight leading-tight m-0">
          {title}
        </h1>
        {subtitle != null && (
          <div className="text-sm text-muted-foreground">{subtitle}</div>
        )}
      </div>
      {actions != null && <div className="shrink-0">{actions}</div>}
    </div>
  );
}
